export default function CallToAction() {
  return (
    <div className="MainBodySection pharmacy-cta-section">
      <div className="container py-5 px-3">
        <div className="pharmacy-cta-card-v2 text-center">
          <div className="pharmacy-cta-glow pharmacy-cta-glow-one" />
          <div className="pharmacy-cta-glow pharmacy-cta-glow-two" />
          <h3 className="font-bold mb-3 text-white">Need Medication or Health Advice?</h3>
          <p className="text-white opacity-75 mb-4 mx-auto" style={{ maxWidth: "680px" }}>
            Speak to our professional pharmacists today or visit our pharmacy
            for fast and reliable service.
          </p>

          <div className="pharmacy-cta-pills mb-4">
            <span>Prescription Support</span>
            <span>OTC Wellness</span>
            <span>Medical Devices</span>
          </div>

          <div className="d-flex flex-wrap justify-content-center gap-3">
            <a href="tel:+255619586628" className="btn btn-light btn-rounded btn-padded">
              Call Now
            </a>
            <a
              href="https://maps.google.com/?q=Kisasa+Plaza+2nd+Floor+Dodoma"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-light btn-rounded btn-padded"
            >
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
